import { Component, OnInit, Input, Output, EventEmitter, ViewChild, Injectable } from '@angular/core';
import { CommonService } from '../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { GestionSygetrack } from '../../recylog/application/gestion.sygetrack';

@Component({
  selector: 'app-edit-param-contenant',
  templateUrl: './edit-param-contenant.component.html',
  styleUrls: ['./edit-param-contenant.component.css']
})
export class EditParamContenantComponent implements OnInit {
  @Output() hidefunction = new EventEmitter<any>();
  listCubage = [];
  listUnite = [];
  listFamille = [];
  listFamilleArt = [];
  listSousFamilleArt = [];
  valeurPossible = [];
  artContenu: any = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
  typeContenant = [];
  tvaEncaissement: Boolean = false;
  valeurCompta = {};
  listTVA = [];
  listFournisseur = [];
  listEtatRecepCont = [{ id: 0, libelle: 'Non renseigné', libelleObjetEntite: 'Non renseigné' }];
  listModePrehension = [{ id: 0, libelle: 'Non renseigné', libelleObjetEntite: 'Non renseigné' }];
  listCouleurCouvert = [{ id: 0, libelle: 'Non renseigné', libelleObjetEntite: 'Non renseigné' }];
  listLocalCont = [{ id: 0, libelle: 'Non renseigné', libelleObjetEntite: 'Non renseigné' }];
  selected = [];
  comboCode = [];
  comboCodeChoisi = "";
  focusIndex = 0;
  selectedRow = {};
  error = '';
  societe: any = {};
  listeTypeCouvercleBac = [
    { id: 0, libelle: 'Non renseigné', libelleObjetEntite: 'Non renseigné' },
    { id: 1, libelleObjetEntite: 'Opercule' },
    { id: 2, libelleObjetEntite: 'Simple' },
    { id: 3, libelleObjetEntite: 'Simple ferme' },
  ]
  listecaracteristiquePAV = [
    { id: 0, libelle: 'Non renseigné', libelleObjetEntite: 'Non renseigné' },
    { id: 1, libelleObjetEntite: 'Simple' },
    { id: 2, libelleObjetEntite: 'PMR' },
    { id: 3, libelleObjetEntite: 'TGP' },
  ]

  //sygetrack
  msgSygetrack = '';
  arg1FuncAfterSygetrack; // clefBenne
  arg2FuncAfterSygetrack = false; // isCreation
  nomInformatiqueImbrique = 'Sygetrack'; // Par défaut
  @ViewChild('loadingSygetrack') loadingSygetrack;

  isEdit: Boolean = false;
  isEmpty: Boolean = false;
  @Input() isAdd: Boolean = false;
  @Input() isFiltreFournisseur: Boolean = false;
  @Input() isFiltreTypeContenant: Boolean = false;
  @Input() isFiltreFlux: Boolean = false;
  @Input() listFiltreEtat = [];
  @Input() bacStock;
  @Input() contenant;
  @Input() parent;

  @ViewChild('msg') msg;

  constructor(public common: CommonService, private modalService: BsModalService) { }

  ngOnInit() {
    if (this.parent == 'StockBacComponent') {
      this.getListBenne().then(datas => {
        if (this.common.verifySession(datas) && datas.data != null) {
          this.comboCode = this.common.arrayToObjet(datas.data);
          if (this.comboCode.length > 0) {
            // formulaire avec le 1er element
            this.changerComboCode(this.comboCode[0]);
          } else {
            // formulaire vide
            this.functionInit();
          }
        }
      });
    } else {
      this.functionInit();
    }
    
    this.getNomInformatiqueEmbarque();
  }
  
  getNomInformatiqueEmbarque() {
    if (this.common.isSiteSygetrack()) {
      const ctrl = this;
      GestionSygetrack.getNomInformatiqueEmbarque(this.common).then(datas => {
        ctrl.nomInformatiqueImbrique = datas.data;
      });
    }
  }  
  
  isInformatiqueEmbarqueSimplicity() {
      return this.nomInformatiqueImbrique == 'Simplicity';
  }  

  changerComboCode(event) {
    this.comboCodeChoisi = event;
    this.contenant = this.comboCodeChoisi;
    this.functionInit();
  }

  getListBenne() {
    const tabFiltreEtat = [];
    this.listFiltreEtat.forEach(l => {
      tabFiltreEtat.push(l.selected);
    });

    const param = {
      'servlet': 'DBGetListBenne',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [
        ['DBGetListBenne'],
        {
          'typeParam': 'int',
          'valeur': (this.bacStock && this.bacStock.fournisseur && this.bacStock.fournisseur.id) ? this.bacStock.fournisseur.id : 0
        },
        {
          'typeParam': 'int',
          'valeur': (this.bacStock && this.bacStock.typeContenant && this.bacStock.typeContenant.id) ? this.bacStock.typeContenant.id : 0
        },
        {
          'typeParam': 'int',
          'valeur': (this.bacStock && this.bacStock.art && this.bacStock.art.id) ? this.bacStock.art.id : 0
        },
        {
          'typeParam': 'boolean',
          'valeur': this.isFiltreFournisseur
        },
        {
          'typeParam': 'boolean',
          'valeur': this.isFiltreTypeContenant
        },
        {
          'typeParam': 'boolean',
          'valeur': this.isFiltreFlux
        },
        tabFiltreEtat
      ]
    };

    return this.common.post('', { param: param });
  }

  getDetail() {
    const param = {
      'servlet': 'DBGetBenne',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetBenne', '' + this.contenant['id']]
    };

    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas) && datas.data != null) {
        this.contenant = datas.data[0];
        this.isEmpty = false;
        const debut = this.contenant['dateEntree'] ? moment(this.contenant['dateEntree'], 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') :
          this.contenant['dateDebutLoc'];
        const fin = this.contenant['dateSortie'] ?   moment(this.contenant['dateSortie'], 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') :
         "01/01/2000";
        this.contenant['modelDebut'] =   this.common.parseDate(debut);
        this.contenant['modelFin'] =  fin ==="01/01/2000" ? '' : this.common.parseDate(fin);
        this.getLibelleContenant(this.contenant['typeContenant']);
        this.contenant['fournisseur'] = this.contenant['fournisseur'] || this.listFournisseur[0];
        this.contenant['couleurCouvercleBac'] = this.contenant['couleurCouvercleBac'] || this.listCouleurCouvert[0];
        this.contenant['etatBac'] = this.contenant['etatBac'] || this.listLocalCont[0];
        this.contenant['etatReceptionBac'] = this.contenant['etatReceptionBac'] || this.listEtatRecepCont[0];
        this.contenant['modePrehensionBac'] = this.contenant['modePrehensionBac'] || this.listModePrehension[0];
        this.listFournisseur.forEach(elt => {
          if (this.contenant['fournisseur'] && this.contenant['fournisseur'].id === elt.id) {
            this.contenant['fournisseur'] = elt;
          }
        });
        this.listCouleurCouvert.forEach(elt => {
          if (this.contenant['couleurCouvercleBac'] && this.contenant['couleurCouvercleBac'].id === elt.id) {
            this.contenant['couleurCouvercleBac'] = elt;
          }
        });
        this.listLocalCont.forEach(elt => {
          if (this.contenant['etatBac'] && this.contenant['etatBac'].id === elt.id) {
            this.contenant['etatBac'] = elt;
          }
        });
        this.listEtatRecepCont.forEach(elt => {
          if (this.contenant['etatReceptionBac'] && this.contenant['etatReceptionBac'].id === elt.id) {
            this.contenant['etatReceptionBac'] = elt;
          }
        });
        this.listModePrehension.forEach(elt => {
          if (this.contenant['modePrehensionBac'] && this.contenant['modePrehensionBac'].id === elt.id) {
            this.contenant['modePrehensionBac'] = elt;
          }
        });
      }
    });
  }

  getLibelleContenant(elt) {
    if (elt) {
      elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? elt.cubage.cubage + ' ' : '') +
        (elt.uniteCont ? elt.uniteCont.libelle : '');
    }
  }

  searchTypecontenant() {
    this.typeContenant = [{ id: 0, libelleObjetEntite: 'Tous' }];
    this.common.getType('listetypeContenant').forEach(elt => {
      elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? elt.cubage.cubage + ' ' : '') +
        (elt.uniteCont ? (elt.uniteCont.libelle || '') : '');
      this.typeContenant.push(elt);
    });
  }

  returnList() {
    this.hidefunction.emit();
  }


  functionInit() {
    this.isEmpty = true;
    this.societe = this.common.local.getObject('paramSociete') || {};
    this.searchTypecontenant();
    this.getListfournisseur().then(() => {
      this.getListEtatRecep().then(() => {
        this.getListModePrehension().then(() => {
          this.getListCouleur().then(() => {
            this.getListLocalCont().then(() => {
              if (this.common.getType('listUnite')) {
                const libellesListUnite = this.common.getType('listUnite')[0];
                const idsListUnite = this.common.getType('listUnite')[1];
                libellesListUnite.forEach((elt, index) => {
                  const objUnite = {
                    id: idsListUnite[index], libelle: libellesListUnite[index],
                    libelleObjetEntite: libellesListUnite[index]
                  };
                  this.listUnite.push(objUnite);
                });
              }
              this.listTVA = this.common.getType('listTVA');
              this.listTVA.forEach(elt => elt.libelleObjetEntite = '' + elt.id);
              const societe = this.common.local.getObject('paramSociete') || {};
              if (this.contenant['id']) {
                this.isEdit = true;
                this.getDetail();
              } else {
                this.contenant = {};
                this.isEmpty = false;
                this.contenant['typeContenant'] = this.typeContenant[0];
                this.contenant['fournisseur'] = this.listFournisseur[0];
                this.contenant['couleurCouvercleBac'] = this.listCouleurCouvert[0];
                this.contenant['etatBac'] = this.listLocalCont[0];
                this.contenant['etatReceptionBac'] = this.listEtatRecepCont[0];
                this.contenant['modePrehensionBac'] = this.listModePrehension[0];
              }
            });
          });
        });
      });
    });
  }

  save() {
    const user = this.common.local.getObject('userInfo') || [];
    if(!this.contenant['dateSortie']) {
       this.contenant['dateSortie'] = "01/01/2000";
    }
    this.contenant['nomclass'] = 'BenneData';
    const param = {
      'servlet': 'DBMAJBenne',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [
        this.contenant,
        {
          'typeParam': 'int',
          'valeur': user[0]
        }
      ]
    };

    this.common.post('', { param: param }).then(dt => {
      if (!dt.data.includes('ERR')) {
        this.arg1FuncAfterSygetrack = dt.data;
        this.arg2FuncAfterSygetrack = this.contenant['id'] ? false : true;
        if (this.common.isSiteSygetrack() && !this.isInformatiqueEmbarqueSimplicity()) {
          this.setMateriel(dt.data);
        } else {
          this.suiteRetourUpdateChantier();
        }
      } else if (dt.data && dt.data.includes('ERR_SETTING_TABLE_0')) {
        this.error = 'Il existe d\u00e9j\u00e0 une benne avec le m\u00eame code';
        this.common.openModal(this.modalService, this.msg);
      } else {
        this.error = dt.message;
        this.common.openModal(this.modalService, this.msg);
      }
    });
  }

  getValeurPossible(row) {
    this.selectedRow = row;
    this.valeurPossible = [];
    row.listeValeursPossibles = row.listeValeursPossibles || [];
    row.listeValeursPossibles.forEach(elt => {
      this.valeurPossible.push(elt);
    });
  }

  valider() {
    const row = this.selectedRow;
    row['listeValeursPossibles'] = this.valeurPossible;
  }

  revert() {
    const row = this.selectedRow;
    this.valeurPossible = [];
  }

  searchArticleContenu(event) {
    this.artContenu = [{ id: 0, libelle: 'Tous', libelleObjetEntite: 'Tous' }];
    const requette = 3;

    return this.common.appelComboK3Fct(requette, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.artContenu = [...this.artContenu, ...datas.data];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  getListfournisseur() {
    const param = {
      'servlet': 'DBGetListFournisseur',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': [
        'DBGetListFournisseur'
      ]
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        // this.listFournisseur = [...this.listFournisseur, ...datas.data];
        this.listFournisseur = [{ id: 0, libelle: 'Aucun', libelleObjetEntite: 'Aucun' }];
        datas.data.forEach(elt => {
          elt.libelle = elt.libelleObjetEntite;
          this.listFournisseur.push(elt);
        });
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }

    });
  }

  getListEtatRecep() {
    const param = {
      'servlet': 'DBGestionObjetEntite',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 5
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.listEtatRecepCont = [...this.listEtatRecepCont, ...datas.data];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  getListModePrehension() {
    const param = {
      'servlet': 'DBGestionObjetEntite',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 6
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.listModePrehension = [...this.listModePrehension, ...datas.data];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  getListCouleur() {
    const param = {
      'servlet': 'DBGestionObjetEntite',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 7
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.listCouleurCouvert = [...this.listCouleurCouvert, ...datas.data];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  getListLocalCont() {
    const param = {
      'servlet': 'DBGestionObjetEntite',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.listLocalCont = [...this.listLocalCont, ...datas.data];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  changeDateDebut(event, row) {
    if (moment(event).isValid()) {
      row['dateEntree'] = moment(event).format('DD/MM/YYYY HH:mm:ss');
      console.log(row['dateEntree']);
    } else {
      row['dateEntree'] = moment().format('DD/MM/YYYY HH:mm:ss');
      console.log(row['dateEntree']);
    }

  }

  changeDateFin(event, row) {
    if (moment(event).isValid()) {
      row['dateSortie'] = moment(event).format('DD/MM/YYYY HH:mm:ss');
      console.log(row['dateSortie']);
    } else {
      row['dateSortie'] = moment().format('DD/MM/YYYY HH:mm:ss');
      console.log(row['dateSortie']);
    }
  }


  // Fermer fenetre sygetrack
  closeSygetrack() {
    this.msgSygetrack = '';
    this.common.closeModal();
    this.suiteRetourUpdateChantier();
  }

  // traitement après click bouton fermer sygetrack
  suiteRetourUpdateChantier() {
    this.common.createLog('14', this.arg1FuncAfterSygetrack, this.arg2FuncAfterSygetrack);
    this.returnList();
  }

  // synchroniser modification contenant sur sygetrack
  setMateriel(id) {
    this.common.openModal(this.modalService, this.loadingSygetrack);
    return GestionSygetrack.setMateriel(id, this.common).then(datas => {
      if (datas.data && datas.data['erreur']) {
        this.msgSygetrack = datas.data['erreur'];

        // Pour debug
        if (datas.data['url']) {
          console.log('URL SYGETRACK SET_MATERIEL : ' + datas.data['url']);
        }
      } else {
        this.closeSygetrack();
      }
    });
  }

  listTypeCouvercle () {

  }
}
